/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import { toast } from 'react-toastify';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { useTranslation } from "../../locale/useTranslation";
import moment from "moment";

export const AcquitionReport = () => {

    const defaultDates = utility.getFirstAndLastDateOfMonth(); 

    const blankDataItem = {
        fromDate: defaultDates.FirstDate,
        toDate: defaultDates.LastDate,
    }
    
    const lang = useTranslation();
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [message, setMessage] = useState("");

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    const isValid = () => {
        if (dataItem.fromDate == undefined || dataItem.Channel == "") {
            toast.error(lang.please_select_from_date_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (dataItem.toDate == undefined || dataItem.toDate == "") {
            toast.error(lang.please_select_to_date_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if( dataItem.fromDate > dataItem.toDate){
            toast.error(lang.from_date_should_be_less_then_to_date_error_message, {
                position: toast.POSITION.TOP_RIGHT
            })
            return false
        }
        return true
    }

    const loadData = async () => {

        if (!isValid()) return;

        setMessage(lang.loading_pleasewait);
        let payload = {
            fromDate: moment(dataItem.fromDate).startOf('day').toDate().getTime(),
            toDate: moment(dataItem.toDate).endOf('day').toDate().getTime(),
        }
        const res = await API.getAcquitionReport(payload);
        console.log(res);
        if (res.success) {
            setGridData(res.data);
        }
        else {
            setGridData([]);
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        setMessage("");
    }

    const downloadExcel = async () => {

        if (gridData.length == 0) {
            toast.error(lang.no_record_found_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        setMessage(lang.downloading_please_wait_message);
        let payload = {
            fromDate: moment(dataItem.fromDate).startOf('day').toDate().getTime(),
            toDate: moment(dataItem.toDate).endOf('day').toDate().getTime(),
            isExport: true
        }
        let res = await API.getAcquitionReport(payload);
        console.log(res);
        if (res.success) {
            window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
            toast.success(`${lang.successfully_download_success_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        setMessage("");
    }

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.acquisition_report_page_breadcrumb}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="d-flex">
                    <div>
                        <label className="form-label">{lang.from_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="fromDate" value={dataItem.fromDate} onChange={onChange} />
                    </div>
                    <div className="ml-4">
                        <label className="form-label">{lang.to_date_label} *</label>
                        <input type="date" className="form-control form-control-sm" name="toDate" value={dataItem.toDate} onChange={onChange} />
                    </div>
                    <div className="ml-3" style={{ marginTop: "22px" }}>
                        <ActionButton name={lang.show_button_text} onClick={loadData} />
                        <RoundButton icon='download' onClick={downloadExcel} style={{ marginLeft: '15px' }} title={lang.download_button_tooltip} />
                        <span className="ml-2">{message}</span>
                    </div>
                   <div className="ml-auto" style={{ marginTop: "35px", color: 'green' }}>
                    <span className="mr-1">{lang.total_acq_label}: { gridData?.length ?? 0}</span>|
                    <span className="ml-1">{lang.total_budget_label}: { gridData?.length > 0 ? gridData?.reduce((total, item) => total + item.Amount, 0) : 0}</span>
                   </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <Grid data={gridData} style={{height: '70vh'}} resizable={true}>
                            <Column field="ContractNumber" title={lang.contract_number_column} />
                            <Column field="Licensor" title={lang.licensor_column} />
                            <Column field="Payee" title={lang.payee_column} />
                            <Column field="StartDate" title={lang.start_date_column} />
                            <Column field="EndDate" title={lang.end_date_column} />
                            <Column field="Title" title={lang.title_column} />
                            <Column field="Amount" title={lang.budget_column} />
                            <Column field="AmortizationRule" title={lang.amortization_rule_column} />
                            <Column field="AmortizationValue" title={lang.amortization_value_column} />
                            <Column field="Exhibitions" title={lang.exhibition_label} />
                            <Column field="ExhibitionsUsed" title={lang.exhibition_used_label} />
                            <Column field="TotalRuns" title={lang.total_runs_label} />

                        </Grid>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default AcquitionReport;